import React from "react";
import { Menu } from "antd";
import { NavLink } from "react-router-dom";
import styled from "@emotion/styled";

const HelperMenu = () => {
  return (
    <Container>
      <Menu>
        <Menu.Item key={"milkHelper"}>
          <NavLink to={"/monkHelper/milk"}>ดื่มดี นมวัว</NavLink>
        </Menu.Item>
        <Menu.Item key={"veggieHelper"}>
          <NavLink to={"/monkHelper/veggie"}>สุขชัวร์ เพิ่มผัก</NavLink>
        </Menu.Item>
        <Menu.Item key={"moveHelper"}>
          <NavLink to={"/monkHelper/move"}>รัก ออกกำลัง</NavLink>
        </Menu.Item>
        <Menu.Item key={"sweetHelper"}>
          <NavLink to={"/monkHelper/sweet"}>หยุดยั้ง น้ำหวาน</NavLink>
        </Menu.Item>
        <Menu.Item key={"overWeightHelper"}>
          <NavLink to={"/monkHelper/overWeight"}>เมื่อน้ำหนักเกิน</NavLink>
        </Menu.Item>
        <Menu.Item key={"lessWeightHelper"}>
          <NavLink to={"/monkHelper/lessWeight"}>เมื่อน้ำหนักน้อย</NavLink>
        </Menu.Item>
        <Menu.Item key={"lessHeightHelper"}>
          <NavLink to={"/monkHelper/lessHeight"}>
            เมื่อความสูง ต่ำกว่าเกณฑ์
          </NavLink>
        </Menu.Item>
      </Menu>
    </Container>
  );
};

export default HelperMenu;

const Container = styled.div`
  font-family: Noto Sans Thai, Noto Sans;
`;
